// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-menu-nav.scss
 ** module id = 48
 ** module chunks = 0 1
 **/